import { getCookie } from '@atlassian/browser-storage-controls';

export const CSRF_COOKIE_NAME = 'csrftoken';
export const CSRF_HEADER_NAME = 'X-CSRFToken';

export const isSameDomain = (url: string): boolean =>
  /^(?!https?:)/.test(url) || url.indexOf(window.location.origin) === 0;

export const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const getRequestHeaders = (url: string, csrftoken: string) => {
  const headers: HeadersInit = {
    // Required for Django's request.is_ajax to work properly in some of our legacy views
    'X-Requested-With': 'XMLHttpRequest',

    // Used by RequestMetaMiddleware to identify API requests originating from Frontbucket, for use
    // in analytic events (facts)
    'X-Bitbucket-Frontend': 'frontbucket',
  };

  // never send tokens cross-(sub)domain
  if (isSameDomain(url)) {
    headers[CSRF_HEADER_NAME] = csrftoken;
  }

  return headers;
};

export default function authRequest(
  url: string,
  options: RequestInit = {},
  csrftoken: string = getCookie(CSRF_COOKIE_NAME) || ''
): Request {
  const headers = getRequestHeaders(url, csrftoken);

  return new Request(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...headers,
      ...(options.headers || {}),
    },
  });
}
